export default "__VITE_ASSET__2a363f87__"